import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../../constants/fetchStatuses';
import { ReducerState } from '../../../store.types';

export const companySelector = ({ companies }: ReducerState) => companies;
export const companiesLoadingSelector = createSelector(
  companySelector,
  ({ fetchCompaniesStatus }) => fetchCompaniesStatus === fetchStatuses.pending,
);
export const companyLoadingSelector = createSelector(
  companySelector,
  ({ fetchCompanyStatus }) => fetchCompanyStatus === fetchStatuses.pending,
);
export const companyCreateLoadingSelector = createSelector(
  companySelector,
  ({ createCompanyStatus }) => createCompanyStatus === fetchStatuses.pending,
);
export const companyUpdateLoadingSelector = createSelector(
  companySelector,
  ({ updateCompanyStatus }) => updateCompanyStatus === fetchStatuses.pending,
);
export const companyDeleteLoadingSelector = createSelector(
  companySelector,
  ({ deleteCompanyStatus }) => deleteCompanyStatus === fetchStatuses.pending,
);
export const companyDeleteDocumentLoadingSelector = createSelector(
  companySelector,
  ({ deleteDocumentStatus }) => deleteDocumentStatus === fetchStatuses.pending,
);
export const companyDocumentsLoadingSelector = createSelector(
  companySelector,
  ({ fetchCompanyDocumentsStatus }) => fetchCompanyDocumentsStatus === fetchStatuses.pending,
);
export const companyRestoreLoadingSelector = createSelector(
  companySelector,
  ({ restoreCompanyStatus }) => restoreCompanyStatus === fetchStatuses.pending,
);
export const documentTypeCreateLoadingSelector = createSelector(
  companySelector,
  ({ createDocumentTypeStatus }) => createDocumentTypeStatus === fetchStatuses.pending,
);

export const resendActivationLinkLoadingSelector = createSelector(
  companySelector,
  ({ resendActivationLinkStatus }) => resendActivationLinkStatus === fetchStatuses.pending,
);

export const companyWithdrawRequestsLoadingSelector = createSelector(
  companySelector,
  ({ fetchCompanyWithdrawRequestsStatus }) => fetchCompanyWithdrawRequestsStatus === fetchStatuses.pending,
);

export const approveCompanyWithdrawRequestLoadingSelector = createSelector(
  companySelector,
  ({ approveCompanyWithdrawRequestStatus }) => approveCompanyWithdrawRequestStatus === fetchStatuses.pending,
);

export const rejectCompanyWithdrawRequestLoadingSelector = createSelector(
  companySelector,
  ({ rejectCompanyWithdrawRequestStatus }) => rejectCompanyWithdrawRequestStatus === fetchStatuses.pending,
);

export const createCompanyWithdrawRequestLoadingSelector = createSelector(
  companySelector,
  ({ createCompanyWithdrawRequestStatus }) => createCompanyWithdrawRequestStatus === fetchStatuses.pending,
);

export const fetchCompanyWithdrawRequestLoadingSelector = createSelector(
  companySelector,
  ({ fetchCompanyWithdrawRequestStatus }) => fetchCompanyWithdrawRequestStatus === fetchStatuses.pending,
);

export const updateCompanyWithdrawRequestLoadingSelector = createSelector(
  companySelector,
  ({ updateCompanyWithdrawRequestStatus }) => updateCompanyWithdrawRequestStatus === fetchStatuses.pending,
);
